<div class="register form-frame wide">
  <app-logo></app-logo>

  <form
    [formGroup]="form"
    (ngSubmit)="sendForm()"
    class="form-frame__body">
    <app-progress [percent]="'40'"> </app-progress>

    <div class="form-frame__body-head">
      <app-back-button></app-back-button>
      <h2 class="headline">{{ "COMPANY_DATA_PAGE.TITLE" | translate }}</h2>
    </div>

    <p class="form-frame__body-description">
      {{ "COMPANY_DATA_PAGE.DESCRIPTION" | translate }}
    </p>

    <div class="form-frame__body-inputs">
      <div
        [class.error]="form.get('companyFormControl')?.invalid && form.get('companyFormControl')?.touched"
        class="input-block">
        <input
          (input)="saveData()"
          formControlName="companyFormControl"
          id="companyName"
          class="input"
          type="text"
          placeholder=" " />
        <label
          for="companyName"
          class="placeholder">
          {{ "COMPANY_DATA_PAGE.COMPANY" | translate }}
        </label>
        <ng-container *ngIf="form.get('companyFormControl')?.invalid && form.get('companyFormControl')?.touched">
          <span
            *ngIf="companyRequiredError"
            class="input-block__error">
            {{ "COMPANY_DATA_PAGE.COMPANY_REQUIRED" | translate }}
          </span>
        </ng-container>
      </div>
      <div class="line">
        <div
          [class.error]="form.get('phoneFormControl')?.invalid && form.get('phoneFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="phoneFormControl"
            id="phone"
            prefix="+7 "
            mask="000 000 00 00"
            inputmode="numeric"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="phone"
            class="placeholder">
            {{ "COMPANY_DATA_PAGE.PHONE" | translate }}
          </label>
          <ng-container *ngIf="form.get('phoneFormControl')?.invalid && form.get('phoneFormControl')?.touched">
            <span
              *ngIf="phoneRequiredError"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.PHONE_REQUIRED" | translate }}
            </span>
            <span
              *ngIf="phoneFormatError"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.PHONE_INVALID" | translate }}
            </span>
          </ng-container>
        </div>

        <div
          [class.error]="form.get('emailFormControl')?.invalid && form.get('emailFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="emailFormControl"
            id="email"
            class="input"
            type="email"
            placeholder=" " />
          <label
            for="email"
            class="placeholder">
            {{ "COMPANY_DATA_PAGE.EMAIL" | translate }}
          </label>
          <ng-container *ngIf="form.get('emailFormControl')?.invalid && form.get('emailFormControl')?.touched">
            <span
              *ngIf="emailRequiredError"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.EMAIL_REQUIRED" | translate }}
            </span>
            <span
              *ngIf="emailFormatError || dotEmailFormatError"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.EMAIL_INVALID" | translate }}
            </span>
          </ng-container>
        </div>
      </div>

      <div class="line">
        <div
          [class.error]="form.get('binFormControl')?.invalid && form.get('binFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="binFormControl"
            mask="000000000000"
            id="bin"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="bin"
            class="placeholder">
            {{ "COMPANY_DATA_PAGE.BIN" | translate }}
          </label>
          <ng-container *ngIf="(form.get('binFormControl')?.invalid && form.get('binFormControl')?.touched) || form.get('binFormControl')?.value">
            <span
              *ngIf="binRequiredError"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.BIN_REQUIRED" | translate }}
            </span>
            <span
              *ngIf="binFormatError && !binRequiredError"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.BIN_MIN" | translate }}
            </span>
            <span
              *ngIf="!binFormatError && !binRequiredError && form.get('binFormControl')?.hasError('iinNotValid')"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.BIN_INVALID" | translate }}
            </span>
          </ng-container>
        </div>
        <div
          [class.active]="isOpenSelect"
          [class.error]="form.get('companyTypeFormControl')?.invalid && form.get('companyTypeFormControl')?.touched"
          class="input-block select">
          <input
            (change)="saveData()"
            formControlName="companyTypeFormControl"
            [readonly]="true"
            (click)="openSelect($event)"
            id="typeCompany"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="typeCompany"
            class="placeholder">
            {{ "COMPANY_DATA_PAGE.TYPE_COMPANY" | translate }}
          </label>
          <ul class="select__list">
            <li
              *ngFor="let item of typesCompany"
              (click)="setCompanyType(item.description)"
              class="select__list-item">
              {{ item.description | translate }}
            </li>
          </ul>
          <ng-container *ngIf="form.get('companyTypeFormControl')?.invalid && form.get('companyTypeFormControl')?.touched">
            <span
              *ngIf="companyTypeRequiredError"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.TYPE_COMPANY_REQUIRED" | translate }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <button
      [disabled]="form.invalid"
      (click)="sendForm()"
      type="submit"
      class="btn btn-accent">
      {{ "COMPANY_DATA_PAGE.CONTINUE" | translate }}
    </button>
  </form>

  <app-lang-select></app-lang-select>
</div>
